import { Typography } from "@mui/material"
import { getSortedHistoryForProject } from "utils/getSortedHistoryForProject"
import { HistoryList } from "components/History/HistoryList"
import { Project, History } from "graphql/types"
import { useEffect, useState } from "react"

type ReportAuditTrailBoxProps = {
  project: Project
}

export const ReportAuditTrailBox = (props: ReportAuditTrailBoxProps) => {
  const { project } = props
  const [history, setHistory] = useState<History[]>([])

  useEffect(() => {
    const newHistory = getSortedHistoryForProject(project)
    setHistory(newHistory)
  }, [project])

  return (
    <>
      <Typography variant="h5">AuditTrail</Typography>
      <HistoryList history={history} />
    </>
  )
}
